import { DialogTitle } from "@material-ui/core";
import React from "react";
import { SubmitForProductionDialogContent } from "./SubmitForProductionDialogContent";

interface ISubmitForProductionDevDialogContentProps {
  showLoading: boolean;
  preValidateError: string | null | undefined;
  submitError: string | null | undefined;
  successMessage: string | null | undefined;
  name: string;
}

export const SubmitForProductionDevDialogContent = (props: ISubmitForProductionDevDialogContentProps) => {
  const { showLoading, preValidateError, submitError, successMessage, name } = props;

  return (
    <>
      <DialogTitle id="alert-dialog-title">{`Submit ${name} Interface for Production`}</DialogTitle>
      <SubmitForProductionDialogContent
        showLoading={showLoading}
        preValidateError={preValidateError}
        submitError={submitError}
        successMessage={successMessage}
        message="This will submit a service call for your interface to be reviewed. It will be locked for editing during this process. If it is approved for
          distribution to customers, any further changes will need to be requested using the Request Field Review or Request API Update buttons in the APIs in Use area. 
          Please verify all details are accurate, all APIs you need are selected, and Custom API Fields are uploaded (if applicable) before submitting."
      />
    </>
  );
};
